export default __webpack_public_path__ + "static/preview-3aa434a517ee5e5b6fcba37b127db8a9.png";